import React from 'react';
import { Main } from "../app/main/Main";
import { CrmInvoiceList } from '../app/invoiceList/CrmInvoiceList';

export const CrmInvoiceListPage = () => {
    return (
        <Main>
            <CrmInvoiceList />
        </Main>
    );
};
